;(function ( $ ) {

    /**
     *  openOverlay
     *  triggers event to open overlay
     **/

    'use strict';

    // Create the defaults once
    var pluginName = 'openOverlay';
    var defaults = {};

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function () {
            this.tagName = $(this.element).get(0).tagName.toLowerCase();
            this.registerEvents();
        },

        registerEvents: function() {
            var _this = this,
                base = window.location.protocol + "//" + window.location.host + window.location.pathname;

            $(this.element).on('click', function(e) {
                if (history.pushState) {
                    window.history.pushState({}, '', base + "#/" + $(this).attr('href'));
                }
            });

            if (this.tagName == 'form') {
                $(this.element).on('click', 'button', function() {
                    $(this).addClass('is-active');
                });
                $(this.element).on('submit', function(e) {
                    var extraParams = {};
                    extraParams.method = $(this).attr('method').toLowerCase();
                    extraParams.action = $(this).attr('action');
                    if ($(this).hasClass('overlay-gray')) {
                        extraParams.bg = 'gray';
                    }
                    if ($(this).hasClass('overlay-event')) {
                        extraParams.bg = 'event';
                    }
                    if ($(this).hasClass('small')) {
                        extraParams.size = 'small';
                    }
                    extraParams.formData = $(this).serializeArray();
                    extraParams.formData.push( { 'name': 'action', 'value': $(this).find('button.is-active').attr('name') } );
                    e.preventDefault();
                    $(document).trigger('overlay.show', extraParams);
                });
            } else {
                $(this.element).on('click', function(e) {
                    e.preventDefault();
                    var extraParams = {};
                    extraParams.clientX =  e.clientX;
                    extraParams.clientY = e.clientY;
                    extraParams.href = $(this).attr('href');
                    if ($(this).data('index') !== undefined) {
                        extraParams.index = $(this).data('index');
                        if ($(this).parents('.li-ticket').length) {

                            extraParams.formData = {
                                salutation: $(this).parents('.li-ticket').find('#ticket-' + extraParams.index + '-salutation').val(),
                                title: $(this).parents('.li-ticket').find('#ticket-' + extraParams.index + '-title').val(),
                                givenname: $(this).parents('.li-ticket').find('#ticket-' + extraParams.index + '-givenname').val(),
                                surname: $(this).parents('.li-ticket').find('#ticket-' + extraParams.index + '-surname').val(),
                                company: $(this).parents('.li-ticket').find('#ticket-' + extraParams.index + '-company').val(),
                                country: $(this).parents('.li-ticket').find('#ticket-' + extraParams.index + '-country').val(),
                                email: $(this).parents('.li-ticket').find('#ticket-' + extraParams.index + '-email').val()
                            };
                        }
                    }
                    if ($(this).hasClass('overlay-gray')) {
                        extraParams.bg = 'gray';
                    }
                    if ($(this).hasClass('overlay-event')) {
                        extraParams.bg = 'event';
                    }
                    if ($(this).hasClass('small')) {
                        extraParams.size = 'small';
                    }
                    if (extraParams.href) {
                        $(document).trigger('overlay.show', extraParams);
                    }
                });
            }
        }
    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
